export default class ReferencesList {
    constructor($el) {
        this.$el = $el;
        this.$references = this.$el.querySelectorAll('[data-open-modal-reference]');

        this.openModal = this.openModal.bind(this);

        this.$references.forEach((reference) => {
            reference.addEventListener('click', (e) => {
                e.preventDefault();
                this.openModal(reference);
            });
        })
    }

    openModal(reference) {
        let hashId = reference.dataset.openModalReference;
        let modalContainer = document.querySelector(`[data-modal-container="${hashId}"]`);
        let modal = modalContainer.querySelector("[data-modal]");

        modalContainer.classList.add('modal__container--open');
        modal.classList.add('modal--open');
    }
}